var option_webview_default = {
  "option": "no8vL",
  "user_choice": "_7RipC",
  "check": "_672fN",
  "image": "-z0Ms",
  "input": "XQ4Fw",
  "title": "HoT8X",
  "centered": "uUcBL",
  "with_result": "LKhkY",
  "list": "n9hIO",
  "with_image": "RXMbV",
  "progress": "v7AQo",
  "progress_value": "K-XQO",
  "label": "g10Wf",
  "cta": "DoCsh",
  "adornment_icon": "jPY3W",
  "remove": "ZxZsN",
  "removeButton": "MffTp",
  "removeButtonIcon": "Q2x7r",
  "overlay": "bf0Av",
  "shown": "gEHMH",
  "dark": "_8Zmns",
  "spinner": "OOPr3",
  "spin": "Zdc8o",
  "grid": "qakMp"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
